module.exports = __webpack_public_path__ + "img/quanb_06.804a71bc.png";